module.exports = __webpack_public_path__ + "img/SettingMenu.5bba4be9.png";